import { render, staticRenderFns } from "./InterviewProcess.vue?vue&type=template&id=4520c85c&scoped=true&"
import script from "./InterviewProcess.vue?vue&type=script&lang=js&"
export * from "./InterviewProcess.vue?vue&type=script&lang=js&"
import style0 from "./InterviewProcess.vue?vue&type=style&index=0&id=4520c85c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4520c85c",
  null
  
)

export default component.exports